import { render, staticRenderFns } from "./SecurityCodeForm.vue?vue&type=template&id=2f2879c4"
import script from "./SecurityCodeForm.vue?vue&type=script&lang=js"
export * from "./SecurityCodeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports